import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonSkeletonText, IonIcon, IonList, IonItem, IonLabel } from '@ionic/angular/standalone';
import { SocialSharing } from "@awesome-cordova-plugins/social-sharing/ngx";
import { LoadingController, ModalController } from "@ionic/angular/standalone";
import { DisplayService, ImageUtil } from "@qid/core";
import { ID } from "../../../../models/ID";
import { Store } from "@ngrx/store";
import { firstValueFrom, map } from "rxjs";
import { Capacitor } from "@capacitor/core";
import { ScannedImage } from "../../../ocr";
import { AuthSelectors } from "../../../authentication";
import { UsersSelectors } from "../../../user";
import { EncryptionKeysService } from "../../../encryption-keys";
import { DocumentAccess, DocumentAccessService } from "../../../document-access";
import { DocumentData } from "../../models/document-data.model";
import { CryptoUtil } from "@qid/crypto";
import { AvatarRoundComponent, SuperBackButtonComponent } from "@qid/super";
import { SidViewComponent } from '../../compenents/index';
import { FormatPhonePipe } from "../../../../pipes/format-phone.pipe";
import { CreateIdPage } from "../create-id/create-id.page";
import { ImageViewerService } from "../../../../components/image-viewer/image-viewer.service";
import domtoimage from 'dom-to-image';

@Component({
  selector: 'app-view-id',
  templateUrl: './view-id.page.html',
  styleUrls: ['./view-id.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SidViewComponent,
    AvatarRoundComponent,
    FormatPhonePipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSkeletonText,
    IonIcon,
    IonList,
    IonItem,
    IonLabel,
    SuperBackButtonComponent
  ],
  providers: [
    SocialSharing
  ]
})
export class ViewIdPage implements OnInit {

  @Input() id: ID;

  @Input() documentData: DocumentData

  activeAccount$ = this.store.select(AuthSelectors.selectActiveAccount)
  authenticatedUser$ = this.store.select(UsersSelectors.selectAuthenticatedUser)

  sharedToAccounts = []
  sharedWithExpanded = false
  readonly sharedWithPreviewCount = 4

  isOwnerView$ = this.activeAccount$.pipe(
    map(account => {
      return account?._id == this.id.account_id
    })
  );

  documentAccess: DocumentAccess = null

  accessRemark: string

  ownerImage = null
  @ViewChild('sidMockupContainer') sidMockupContainer?: ElementRef<HTMLElement>;

  constructor(public modalController: ModalController,
    private socialSharing: SocialSharing,
    private loadingController: LoadingController,
    private store: Store,
    private displayService: DisplayService,
    private encryptionService: EncryptionKeysService,
    private documentAccessService: DocumentAccessService,
    private imageViewerService: ImageViewerService
  ) {
  }

  ngOnInit() {

  }

  ionViewDidEnter() {
    this.fetchDocumentAccess();
  }

  // async decryptId() {
  //   const activeAccount = await firstValueFrom(this.activeAccount$)
  //   const keys = await this.encryptionService.read(activeAccount._id)
  //
  //   if (this.id && this.id.aesRsaEncryptedData) {
  //     const privateKey = await CryptoUtil.extractPrivateKeyFromPassword("Manu1234@", keys.key, keys.salt)
  //     const data = await CryptoUtil.decryptDataWithRsaAndAes(
  //       this.id.aesRsaEncryptedData.dataCipher,
  //       privateKey,
  //       this.id.aesRsaEncryptedData.rsaEncryptedAesKey,
  //       this.id.aesRsaEncryptedData.ivBase64)
  //     if (data) {
  //       this.id.documentData = JSON.parse(data)
  //     }
  //   }
  // }

  getImage(url: string) {
    return ImageUtil.getImageSource(url);
  }

  close() {
    this.modalController.dismiss({ id: this.id });
  }

  async fetchDocumentAccess() {
    try {
      const res = await this.documentAccessService.findByDocumentId(this.id?._id);

      if (!res.data) {
        return this.displayService.toast({
          message: res.errorMessage
        })
      }

      const documentAccesses: DocumentAccess[] = res.data;

      // Use a Set to track unique grantedToAccount_id values
      const addedIds = new Set<string>();

      const activeAccount = await firstValueFrom(this.activeAccount$)


      for (const access of documentAccesses) {

        if (!access.grantedToAccount) {
          continue;
        }

        if (activeAccount?._id == access.grantedToAccount?._id ||
          activeAccount?._id == access.grantedToAccount?.parentAccountId) {
          this.documentData = access.documentData
          this.accessRemark = access.accessRemark
          this.documentAccess = access
        }

        if (access.grantedToAccount?._id == access?.documentOwnerAccount?._id) {
          continue;
        }

        if (!addedIds.has(access.grantedToAccount._id) &&
          access.grantedToAccount?.name) {
          addedIds.add(access.grantedToAccount._id);
          this.sharedToAccounts.push(access.grantedToAccount);
        }
      }


      if (this.documentAccess?.aesRsaEncryptedData) {
        const keys = await this.encryptionService.read(activeAccount._id)
        const privateKey = await CryptoUtil.decryptPrivateKey(
          keys.salt, keys.iv, keys.key, "dummyPassword"
        )
        if (privateKey) {
          const data = await CryptoUtil.decryptDataWithRsaAndAes(
            this.documentAccess.aesRsaEncryptedData.dataCipher,
            privateKey,
            this.documentAccess.aesRsaEncryptedData.rsaEncryptedAesKey,
            this.documentAccess.aesRsaEncryptedData.ivBase64
          )
        }
      }

      this.createPhoto()

    } catch (error) {
      console.error('Error fetching document access:', error);
    }
  }

  async createPhoto() {

    if (this.documentAccess?.documentOwnerAccount?.displayPictureUrl?.length > 0) {
      this.ownerImage = ImageUtil.getImageSource(this.documentAccess?.documentOwnerAccount?.displayPictureUrl)
      return
    }

    if (this.documentAccess?.document?.sid?.name != 'Aadhaar' && this.documentAccess?.document?.sid?.name != 'Passport') {
      return;
    }

    const landmarks = this.documentAccess?.documentData?.scannedImages[0]?.faceLandmark
    const imageUrl = this.documentAccess?.documentData?.scannedImages[0]?.imageUrl

    let image = await ImageUtil.getImageUrlFromPhotoLandmarks(ImageUtil.getImageSource(imageUrl), landmarks)

    if (image) {
      this.ownerImage = image
    }

  }

  async viewPhoto(images: ScannedImage[], index: number = 0) {
    const imageUrlArray = images.map(item => item.imageUrl)

    // Get user name
    const user = await firstValueFrom(this.authenticatedUser$);
    const userName = user?.name || '';

    // Get SID name
    const sidName = this.id?.sid?.name || '';

    // Get photo name from keyString or generate based on index
    const photoName = images[index]?.keyString || `photo-${index + 1}`;

    this.imageViewerService.open(imageUrlArray, true, index, userName, sidName, photoName);
  }

  async updateDocumentClicked() {
    const account = await firstValueFrom(this.activeAccount$)
    const modal = await this.modalController.create({
      component: CreateIdPage,
      componentProps: {
        id: this.id,
        sidId: this.id.sid._id,
        account: { ...account }
      },
      animated: true
    })

    await modal.present();
    const res = await modal.onDidDismiss()
    if (res && res.data.id) {
      this.fetchDocumentAccess()
    }
  }

  share = async (event: Event, image: ScannedImage) => {
    event.stopPropagation();
    const dataUrl = this.getImage(image.imageUrl);

    if (Capacitor.getPlatform() == 'android') {
      return this.socialSharing.share(this.id?.sid?.name, 'www.oneqid.com', dataUrl);
    }
    if (Capacitor.getPlatform() == 'ios') {
      return this.socialSharing.shareViaWhatsApp(this.id?.sid?.name, dataUrl, "https://oneqid.com");
    }
  }

  shareToLocal = async (event: Event, image: ScannedImage) => {
    event.stopPropagation();
    const loader = await this.loadingController.create({
      message: "Downloading"
    })

    loader.present();

    const imageUrl = ImageUtil.getImageSource(image.imageUrl)
    const uri = await ImageUtil.downloadImage(imageUrl);
    loader.dismiss()
    if (uri && uri.length > 0) {
      this.displayService.toast({
        message: "Image Saved"
      })
    }

  }

  async shareMockup(event: Event): Promise<void> {
    event.stopPropagation();
    const dataUrl = await this.getSidMockupDataUrl();
    if (!dataUrl) {
      return;
    }

    if (Capacitor.getPlatform() == 'android') {
      await this.socialSharing.share(this.id?.sid?.name, 'www.oneqid.com', dataUrl);
      return;
    }
    if (Capacitor.getPlatform() == 'ios') {
      await this.socialSharing.shareViaWhatsApp(this.id?.sid?.name, dataUrl, "https://oneqid.com");
    }
  }

  async saveMockupToLocal(event: Event): Promise<void> {
    event.stopPropagation();
    const dataUrl = await this.getSidMockupDataUrl();
    if (!dataUrl) {
      return;
    }

    const loader = await this.loadingController.create({
      message: "Downloading"
    });
    await loader.present();

    const uri = await ImageUtil.downloadImage(dataUrl);
    await loader.dismiss();
    if (uri && uri.length > 0) {
      this.displayService.toast({
        message: "Image Saved"
      });
    }
  }

  private async getSidMockupDataUrl(): Promise<string | null> {
    const mockupEl = this.sidMockupContainer?.nativeElement;
    if (!mockupEl) {
      this.displayService.toast({ message: 'Preview not ready yet' });
      return null;
    }

    try {
      return await domtoimage.toPng(mockupEl);
    } catch (error) {
      console.error('Failed to capture SID mockup', error);
      this.displayService.toast({ message: 'Unable to capture preview' });
      return null;
    }
  }


}
